import Cookies from 'universal-cookie';
import { CART_ID } from 'global/constants';

export const clearCartId = () => {
  const cookies = new Cookies();
  cookies.remove(CART_ID, { path: '/' });
};

export const isCartIdError = (error) => {
  return error?.message?.includes('Could not find a cart with ID');
};